import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaDesktop,
  FaPrint,
  FaCopy,
  FaServer,
  FaWifi,
  FaTools,
  FaHardHat,
  FaShoppingCart,
  FaBoxOpen,
  FaCogs,
  FaUsers,
  FaChartLine,
  FaExclamationTriangle,
  FaCheckCircle,
  FaClock,
  FaPhone,
  FaEnvelope,
  FaRocket,
  FaGraduationCap,
  FaStar,
  FaArrowRight,
  FaDownload,
  FaPlay,
  FaStop,
  FaSearch,
  FaBullseye,
  FaCog,
  FaLaptop,
  FaMobile,
  FaBuilding,
  FaCertificate,
  FaMoneyBillWave,
  FaHandshake,
  FaShieldAlt,
  FaRandom,
} from "react-icons/fa";
import "./PcNetworksPage.css";

const PcNetworksPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activeService, setActiveService] = useState("computers");
  const [selectedAdvantage, setSelectedAdvantage] = useState(null);

  const pcServices = [
    {
      id: "computers",
      icon: FaDesktop,
      title: "Počítačové zostavy",
      price: "Od €300",
      description:
        "Zostavenie počítačov na mieru podľa vašich potrieb a požiadaviek",
      features: [
        "Značkové komponenty špičkovej kvality",
        "Kompatibilita všetkých komponentov",
        "Zostavenie na mieru užívateľa",
        "Optimálny pomer cena/výkon",
        "Garancia na všetky komponenty",
        "Technická podpora a servis",
      ],
      duration: "2-3 pracovné dni",
      deliverables: "Kompletná zostava + Inštalácia + Nastavenie + Záruka",
    },
    {
      id: "printers",
      icon: FaPrint,
      title: "Tlačiarne a kopírky",
      price: "Od €150",
      description:
        "Dodávka a servis tlačiarní, kopírok a multifunkčných zariadení",
      features: [
        "Laserové a atramentové tlačiarne",
        "Multifunkčné zariadenia",
        "Profesionálne kopírky",
        "Servis a údržba",
        "Dodávka toneru a náplní",
        "Leasing a prenájom zariadení",
      ],
      duration: "1-2 pracovné dni",
      deliverables: "Zariadenie + Inštalácia + Nastavenie + Školenie",
    },
    {
      id: "components",
      icon: FaCogs,
      title: "IT komponenty",
      price: "Podľa špecifikácie",
      description:
        "Dodávka jednotlivých komponentov a rozšírenie existujúcich zostáv",
      features: [
        "Procesory a základné dosky",
        "Pamäte RAM a úložiská",
        "Grafické karty a monitory",
        "Sieťové komponenty",
        "Periférie a príslušenstvo",
        "Kompatibilita s existujúcimi systémami",
      ],
      duration: "1-3 pracovné dni",
      deliverables: "Komponenty + Inštalácia + Konfigurácia + Test",
    },
    {
      id: "networks",
      icon: FaWifi,
      title: "Počítačové siete",
      price: "Od €200",
      description: "Návrh, výstavba a správa firemných počítačových sietí",
      features: [
        "Návrh sieťovej topológie",
        "Inštalácia sieťového káblovania",
        "Konfigurácia smerovačov a switchov",
        "Bezdrôtové siete Wi-Fi",
        "Správa a monitoring siete",
        "Bezpečnosť sieťovej infraštruktúry",
      ],
      duration: "3-7 pracovných dní",
      deliverables: "Sieť + Konfigurácia + Dokumentácia + Správa",
    },
  ];

  const advantages = [
    {
      id: "price",
      title: "Výhodná cena",
      icon: FaMoneyBillWave,
      description:
        "Skladačky ponúkajú lepší pomer cena/výkon ako značkové počítače",
      details: [
        "Úspora až 30% oproti značkovým počítačom",
        "Investujete len do komponentov, ktoré potrebujete",
        "Žiadne platby za zbytočný software",
        "Flexibilné cenové kategórie",
      ],
    },
    {
      id: "upgrade",
      title: "Možnosť upgradu",
      icon: FaRandom,
      description:
        "Kedykoľvek môžete dopĺňať alebo vymeniť jednotlivé komponenty",
      details: [
        "Postupný upgrade podľa potrieb",
        "Kompatibilné komponenty",
        "Predĺženie životnosti počítača",
        "Investícia do budúcnosti",
      ],
    },
    {
      id: "service",
      title: "Lacnejší servis",
      icon: FaTools,
      description: "Pozáručný servis je rýchlejší a cenovo dostupnejší",
      details: [
        "Nie ste odkázaní na značkový servis",
        "Rýchlejšie obstaranie náhradných dielov",
        "Lokálna technická podpora",
        "Flexibilné servisné podmienky",
      ],
    },
    {
      id: "repair",
      title: "Jednoduchšie opravy",
      icon: FaHandshake,
      description: "Pri poruche nie je nutné meniť celé komponenty",
      details: [
        "Výmena len chybného dielu",
        "Úspora času a nákladov",
        "Presná diagnostika problému",
        "Preventívne opatrenia",
      ],
    },
  ];

  const partners = [
    { name: "IBM", logo: "/partners/ibm-logo.png" },
    { name: "HP", logo: "/partners/hp-logo.png" },
    { name: "Microsoft", logo: "/partners/microsoft-logo.png" },
    { name: "3COM", logo: "/partners/3com-logo.png" },
    { name: "Intel", logo: "/partners/intel-logo.png" },
    { name: "AMD", logo: "/partners/amd-logo.png" },
  ];

  const stats = [
    { value: "15+", label: "Rokov skúseností" },
    { value: "1000+", label: "Zostavených PC" },
    { value: "50+", label: "Spokojných firiem" },
    { value: "24/7", label: "Technická podpora" },
  ];

  return (
    <div className="pc-networks-page">
      {/* Hero Section */}
      <section className="pc-hero">
        <div className="hero-background">
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Správa PC a sietí</h1>
              <p className="hero-subtitle">
                Predaj výpočtovej techniky a komplexné IT riešenia
              </p>
              <p className="hero-description">
                Na základe Vašich potrieb a požiadaviek Vám dodáme výpočtovú
                techniku, ako počítače, tlačiarne, kopírky a ďalšie IT
                komponenty a zariadenia, o ktoré sa Vám môžeme aj starať.
              </p>
              <div className="hero-stats">
                {stats.map((stat, index) => (
                  <div key={index} className="hero-stat">
                    <span className="stat-number">{stat.value}</span>
                    <span className="stat-label">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="hero-visual">
              <div className="hero-icon">
                <FaDesktop />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="pc-services">
        <div className="container">
          <div className="section-header">
            <h2>Naše IT služby</h2>
            <p>Kompletný servis výpočtovej techniky a IT infraštruktúry</p>
          </div>

          <div className="services-tabs">
            {pcServices.map((service) => (
              <button
                key={service.id}
                className={`service-tab ${
                  activeService === service.id ? "active" : ""
                }`}
                onClick={() => setActiveService(service.id)}
              >
                <service.icon />
                <span>{service.title}</span>
              </button>
            ))}
          </div>

          <div className="service-content_">
            {pcServices
              .filter((service) => service.id === activeService)
              .map((service) => (
                <div key={service.id} className="service-detail">
                  <div className="service-info">
                    <div className="service-header">
                      <div className="title-icon">
                        <h3>{service.title}</h3>
                        <service.icon className="service-icon_" />
                      </div>
                      <div>
                        <p className="service-price">{service.price}</p>
                      </div>
                    </div>
                    <p className="service-description">{service.description}</p>

                    <div className="service-features">
                      <h4>Čo zahŕňame:</h4>
                      <ul>
                        {service.features.map((feature, index) => (
                          <li key={index}>
                            <FaCheckCircle />
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>

                    <div className="service-meta">
                      <div className="meta-item">
                        <FaClock />
                        <span>Doba realizácie: {service.duration}</span>
                      </div>
                      <div className="meta-item">
                        <FaBoxOpen />
                        <span>{service.deliverables}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="pc-advantages">
        <div className="container">
          <div className="section-header">
            <h2>Výhody kúpy "skladačky"</h2>
            <p>
              Pri kúpe počítača sa ponúkajú dve možnosti - "značkový počítač"
              alebo skladaný počítač tzv. "skladačka"
            </p>
          </div>

          <div className="advantages-grid">
            {advantages.map((advantage) => (
              <div
                key={advantage.id}
                className={`advantage-card ${
                  selectedAdvantage === advantage.id ? "active" : ""
                }`}
                onClick={() =>
                  setSelectedAdvantage(
                    selectedAdvantage === advantage.id ? null : advantage.id
                  )
                }
              >
                <div className="advantage-header">
                  <advantage.icon className="advantage-icon" />
                  <h3>{advantage.title}</h3>
                </div>
                <p className="advantage-description">{advantage.description}</p>

                {selectedAdvantage === advantage.id && (
                  <div className="advantage-details">
                    <ul>
                      {advantage.details.map((detail, index) => (
                        <li key={index}>
                          <FaArrowRight />
                          {detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="advantage-toggle">
                  {selectedAdvantage === advantage.id
                    ? "Skryť detaily"
                    : "Zobraziť viac"}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Section */}
      <section className="pc-quality">
        <div className="container">
          <div className="quality-content">
            <div className="quality-text">
              <h2>Kvalita a kompatibilita</h2>
              <p>
                Často sa stretávame s prípadmi, že doma zostavený počítač
                nepracuje podľa predstáv a potrieb užívateľa, keďže jednotlivé
                komponenty nie sú kompatibilné.
              </p>
              <p>
                Zverte zostavenie Vášho počítač do našich rúk a my Vám
                zabezpečíme kompatibilitu všetkých druhov techniky a
                komponentov, taktiež s technológiami, ktoré ste si už
                zaobstarali predtým.
              </p>

              <div className="quality-features">
                <div className="quality-feature">
                  <FaCertificate />
                  <div>
                    <h4>Značkové komponenty</h4>
                    <p>
                      Používame len komponenty špičkovej kvality od renomovaných
                      výrobcov
                    </p>
                  </div>
                </div>
                <div className="quality-feature">
                  <FaShieldAlt />
                  <div>
                    <h4>Garantovaná kompatibilita</h4>
                    <p>
                      Všetky komponenty sú otestované na vzájomnú kompatibilitu
                    </p>
                  </div>
                </div>
                <div className="quality-feature">
                  <FaBullseye />
                  <div>
                    <h4>Zostavenie na mieru</h4>
                    <p>
                      Počítač zostavíme presne podľa vašich potrieb a
                      požiadaviek
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="quality-visual">
              <div className="quality-stats">
                <div className="quality-stat">
                  <FaStar />
                  <span>99% spokojnosť</span>
                </div>
                <div className="quality-stat">
                  <FaCheckCircle />
                  <span>2 roky záruka</span>
                </div>
                <div className="quality-stat">
                  <FaRocket />
                  <span>Rýchla dodávka</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Custom Solutions */}
      <section className="pc-custom">
        <div className="container">
          <div className="custom-content">
            <div className="custom-text">
              <h2>Riešenie na mieru</h2>
              <p>
                Záleží len od Vás čo očakávate od Vášho počítača a my Vám ho
                zostavíme presne na mieru. V prípade, že nemáte konkrétne
                požiadavky, poskladáme pre Vás najoptimálnejšiu počítačovú
                zostavu podľa účelu, na ktorý bude využívaná.
              </p>

              <div className="custom-types">
                <div className="custom-type">
                  <FaBuilding />
                  <h4>Pre firmy</h4>
                  <p>Firemné workstations a servery</p>
                </div>
                <div className="custom-type">
                  <FaUsers />
                  <h4>Pre domácnosti</h4>
                  <p>Domáce PC pre prácu a zábavu</p>
                </div>
                <div className="custom-type">
                  <FaGraduationCap />
                  <h4>Pre školy</h4>
                  <p>Učebne a laboratóriá</p>
                </div>
              </div>
            </div>

            <div className="custom-cta">
              <Link to="/kontakt" className="btn btn-primary btn-large">
                <FaPhone />
                Získajte ponuku na mieru
              </Link>
              <p>Bezplatná konzultácia a cenová ponuka</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PcNetworksPage;
